/**
 * Klaiyi：Block SizeSwatch 属性图（option_images 接口）+ 放大预览 + 主图/缩略图联动
 */
(function ($) {
  var PLACEHOLDER_SVG =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 140'%3E%3Crect fill='%23eceef0' width='120' height='140'/%3E%3C/svg%3E";

  var OPTION_IMAGE_ZOOM_ICON_URL =
    "https://cdn.shopify.com/s/files/1/1720/3725/files/Frame_2085663485.png?v=1778491374";

  var CAPTION_LINE_HEIGHT_ONE_PX = 22;
  var CAPTION_LINE_HEIGHT_TWO_PX = 18;
  /** 按 18px 行高测量 scrollHeight，超过此值视为 2 行 */
  var CAPTION_TWO_LINE_SCROLL_THRESHOLD = 20;

  function normKey(s) {
    return String(s || "")
      .trim()
      .toLowerCase();
  }

  /** 兼容 API / DOM：纯数字、gid://shopify/ProductVariant/xxx */
  function normalizeVariantId(val) {
    if (val == null || val === "") return "";
    var s = String(val).trim();
    var gid = s.match(/\/ProductVariant\/(\d+)/i);
    if (gid) return gid[1];
    var tail = s.match(/(\d{6,})$/);
    if (tail) return tail[1];
    return s.replace(/\D/g, "") || s;
  }

  function getOptionImagesRows(json) {
    if (Array.isArray(json)) return json;
    if (json && typeof json === "object") {
      if (Array.isArray(json.data)) return json.data;
      if (Array.isArray(json.images)) return json.images;
      if (Array.isArray(json.result)) return json.result;
      if (Array.isArray(json.items)) return json.items;
      if (json.data && typeof json.data === "object" && !Array.isArray(json.data)) {
        return Object.keys(json.data).map(function (k) {
          var v = json.data[k];
          return typeof v === "object" && v !== null
            ? $.extend({ __key: k }, v)
            : { value: k, url: v };
        });
      }
    }
    return [];
  }

  /** 接口成功但 data/images 等列表为空：表示后台已清空属性图，不应再用变体主图兜底 */
  function isOptionImagesApiExplicitlyEmpty(json) {
    if (json == null) return false;
    if (Array.isArray(json)) return json.length === 0;
    if (typeof json !== "object") return false;
    if (Array.isArray(json.data)) return json.data.length === 0;
    if (Array.isArray(json.images)) return json.images.length === 0;
    if (Array.isArray(json.result)) return json.result.length === 0;
    if (Array.isArray(json.items)) return json.items.length === 0;
    return false;
  }

  window.klaiyiIsOptionImagesApiExplicitlyEmpty = isOptionImagesApiExplicitlyEmpty;

  function parseOptionImagesPayload(json) {
    var rows = getOptionImagesRows(json);
    var byValue = {};
    var byComposite = {};
    var byOptionIndexComposite = {};
    var byVariantId = {};
    var byOptionIndexValueIndex = {};
    rows.forEach(function (row) {
      if (!row || typeof row !== "object") return;
      var val =
        row.value_name ||
        row.option_value ||
        row.value ||
        row.name ||
        row.option1 ||
        row.title ||
        row.label ||
        row.__key ||
        "";
      var url =
        row.image ||
        row.url ||
        row.src ||
        row.image_url ||
        row.thumbnail ||
        row.pic ||
        "";
      var optName = row.option_name || row.option || row.option_title || "";
      var mid = row.media_id || row.shopify_media_id || row.mediaId;
      var productImageIndex =
        row.product_image_index !== undefined && row.product_image_index !== null
          ? row.product_image_index
          : row.productImageIndex;
      var mediaPosition =
        row.media_position !== undefined && row.media_position !== null
          ? row.media_position
          : row.mediaPosition !== undefined && row.mediaPosition !== null
            ? row.mediaPosition
            : row.position;
      if (!url) return;
      var entry = {
        url: url,
        mediaId: mid,
        productImageIndex: productImageIndex,
        mediaPosition: mediaPosition,
      };
      var variantIdRaw =
        row.variant_id !== undefined && row.variant_id !== null
          ? row.variant_id
          : row.variantId !== undefined && row.variantId !== null
            ? row.variantId
            : row.shopify_variant_id;
      if (
        (variantIdRaw === undefined || variantIdRaw === null || variantIdRaw === "") &&
        row.__key &&
        /^\d+$/.test(String(row.__key).trim())
      ) {
        variantIdRaw = row.__key;
      }
      var variantId = normalizeVariantId(variantIdRaw);
      if (variantId) byVariantId[variantId] = entry;
      var oi =
        row.option_index !== undefined && row.option_index !== null
          ? String(row.option_index)
          : "";
      var valIdxRaw =
        row.option_value_index !== undefined && row.option_value_index !== null
          ? row.option_value_index
          : row.value_index !== undefined && row.value_index !== null
            ? row.value_index
            : row.optionValueIndex;
      if (oi !== "" && valIdxRaw !== undefined && valIdxRaw !== null && valIdxRaw !== "") {
        byOptionIndexValueIndex[oi + "::" + String(valIdxRaw)] = entry;
      }
      var nk = normKey(val);
      if (nk) byValue[nk] = entry;
      var ck = normKey(optName) + "::" + nk;
      if (ck !== "::") byComposite[ck] = entry;
      if (oi !== "" && nk) {
        byOptionIndexComposite[oi + "::" + nk] = entry;
      }
    });
    return {
      byValue: byValue,
      byComposite: byComposite,
      byOptionIndexComposite: byOptionIndexComposite,
      byVariantId: byVariantId,
      byOptionIndexValueIndex: byOptionIndexValueIndex,
    };
  }

  function getLabelVariantId($label) {
    if (!$label || !$label.length) return "";
    var raw = $label.attr("data-variant-id");
    if (raw === undefined || raw === null || String(raw).trim() === "") {
      raw = $label.data("variant-id");
    }
    return normalizeVariantId(raw);
  }

  /** 详情 #json-script / 快购 quickShopProductJson：变体主图兜底（接口未命中时） */
  function buildVariantImageFallbackMaps($scope) {
    var variants = null;
    var $root = $scope && $scope.length ? $scope : $();
    var isQuickShop =
      $root.length &&
      ($root.is(".quick_shop") || $root.closest(".quick_shop").length > 0);

    if (isQuickShop && window.quickShopProductJson && window.quickShopProductJson.variants) {
      variants = window.quickShopProductJson.variants;
    } else {
      var el = document.querySelector(".ProductForm #json-script");
      if (el) {
        try {
          var data = JSON.parse(el.textContent);
          variants = data.product && data.product.variants;
        } catch (eJson) {}
      }
    }

    if (!variants || !variants.length) return null;

    var byVariantId = {};
    variants.forEach(function (v) {
      if (!v || v.id == null) return;
      var url = "";
      if (v.featured_image && v.featured_image.src) {
        url = v.featured_image.src;
      } else if (typeof v.image === "string") {
        url = v.image;
      } else if (v.image && v.image.src) {
        url = v.image.src;
      }
      var mid =
        v.featured_media && v.featured_media.id != null
          ? v.featured_media.id
          : v.featured_image && v.featured_image.id != null
            ? v.featured_image.id
            : null;
      if (!url && !mid) return;
      byVariantId[normalizeVariantId(v.id)] = {
        url: url,
        mediaId: mid,
        productImageIndex: null,
        mediaPosition: null,
      };
    });

    return Object.keys(byVariantId).length ? { byVariantId: byVariantId } : null;
  }

  function mergeMapsForResolve(apiMaps, fallbackMaps) {
    if (!fallbackMaps || !fallbackMaps.byVariantId) return apiMaps;
    return {
      byValue: apiMaps.byValue,
      byComposite: apiMaps.byComposite,
      byOptionIndexComposite: apiMaps.byOptionIndexComposite,
      byVariantId: $.extend({}, fallbackMaps.byVariantId, apiMaps.byVariantId || {}),
      byOptionIndexValueIndex: apiMaps.byOptionIndexValueIndex || {},
    };
  }

  /**
   * 匹配顺序：接口 option/value 优先，变体主图仅作兜底。
   * 避免 label 带 data-variant-id 时，featured_image 抢在 option_images 的 GIF 之前生效。
   */
  function resolveEntryForLabel($label, maps) {
    var optIdxAttr = $label.attr("data-option-index");
    var optIdx =
      optIdxAttr !== undefined && optIdxAttr !== null && optIdxAttr !== ""
        ? String(optIdxAttr)
        : $label.data("option-index") != null
          ? String($label.data("option-index"))
          : "";
    var valIdxAttr = $label.attr("data-option-value-index");
    var valIdx =
      valIdxAttr !== undefined && valIdxAttr !== null && valIdxAttr !== ""
        ? String(valIdxAttr)
        : $label.data("option-value-index") != null
          ? String($label.data("option-value-index"))
          : "";
    if (
      optIdx !== "" &&
      valIdx !== "" &&
      maps.byOptionIndexValueIndex &&
      maps.byOptionIndexValueIndex[optIdx + "::" + valIdx]
    ) {
      return maps.byOptionIndexValueIndex[optIdx + "::" + valIdx];
    }

    var rawVal = $label.attr("data-value");
    var val = normKey(rawVal !== undefined ? rawVal : $label.data("value"));
    var rawOpt = $label.attr("data-option-name");
    var opt = normKey(rawOpt !== undefined ? rawOpt : $label.data("option-name"));
    if (optIdx !== "" && maps.byOptionIndexComposite) {
      var byOi = maps.byOptionIndexComposite[optIdx + "::" + val];
      if (byOi) return byOi;
    }
    var c = maps.byComposite[opt + "::" + val];
    if (c) return c;
    if (maps.byValue && maps.byValue[val]) {
      return maps.byValue[val];
    }

    var variantId = getLabelVariantId($label);
    if (variantId && maps.byVariantId && maps.byVariantId[variantId]) {
      return maps.byVariantId[variantId];
    }
    return undefined;
  }

  /** 兼容 API：纯数字、字符串、gid://shopify/Media/xxx */
  function extractNumericShopifyId(val) {
    if (val == null || val === "") return "";
    var s = String(val).trim();
    var gid = s.match(/\/Media\/(\d+)/i);
    if (gid) return gid[1];
    var tail = s.match(/(\d{6,})$/);
    if (tail) return tail[1];
    return s.replace(/\D/g, "") || s;
  }

  function galleryMediaIdsMatch(cellAttr, apiVal) {
    if (cellAttr == null || apiVal == null) return false;
    var a = String(cellAttr).trim();
    var b = String(apiVal).trim();
    if (a === b) return true;
    var na = extractNumericShopifyId(a);
    var nb = extractNumericShopifyId(b);
    return na !== "" && nb !== "" && na === nb;
  }

  function galleryImageUrlKey(url) {
    if (!url || url.indexOf("data:") === 0) return "";
    try {
      var u = new URL(url, window.location.href);
      var file = u.pathname.split("/").pop() || "";
      var v = u.searchParams.get("v");
      return v ? file + "?v=" + v : file;
    } catch (e1) {
      return String(url).split("?")[0];
    }
  }

  function stripShopifyImageSizeInName(filename) {
    return String(filename || "")
      .replace(/_(\d+)x(\d+)\./gi, ".")
      .replace(/_(\d+)x\./gi, ".");
  }

  function galleryImageUrlsLikelySame(u1, u2) {
    if (!u1 || !u2) return false;
    if (u1 === u2) return true;
    var k1 = galleryImageUrlKey(u1);
    var k2 = galleryImageUrlKey(u2);
    if (k1 && k2 && k1 === k2) return true;
    var f1 = stripShopifyImageSizeInName(k1.split("/").pop().split("?")[0]).toLowerCase();
    var f2 = stripShopifyImageSizeInName(k2.split("/").pop().split("?")[0]).toLowerCase();
    return f1 !== "" && f1 === f2;
  }

  /** 协议相对 //cdn... → https://cdn...，便于与主图 src 比对、赋值 */
  function quickShopAbsolutizeImageUrl(u) {
    if (u == null || u === "") return "";
    var s = String(u).trim();
    if (s.indexOf("//") === 0) {
      s = "https:" + s;
    }
    return s;
  }

  /** 快购：属性图 URL 与主图 URL 多策略对齐（CDN/尺寸参数/同文件不同路径） */
  function quickShopImageUrlsMatch(u1, u2) {
    if (galleryImageUrlsLikelySame(u1, u2)) return true;
    if (!u1 || !u2) return false;
    var a = quickShopAbsolutizeImageUrl(String(u1).trim());
    var b = quickShopAbsolutizeImageUrl(String(u2).trim());
    if (!a || !b || a.indexOf("data:") === 0 || b.indexOf("data:") === 0) return false;
    try {
      var ua = new URL(a, window.location.href);
      var ub = new URL(b, window.location.href);
      var pa = ua.pathname.replace(/\/+/g, "/").toLowerCase();
      var pb = ub.pathname.replace(/\/+/g, "/").toLowerCase();
      if (pa === pb) return true;
      var fa = stripShopifyImageSizeInName(pa.split("/").pop() || "").toLowerCase();
      var fb = stripShopifyImageSizeInName(pb.split("/").pop() || "").toLowerCase();
      if (fa && fb && fa === fb) return true;
    } catch (eM) {}
    var tailA = a.split("?")[0].toLowerCase();
    var tailB = b.split("?")[0].toLowerCase();
    if (tailA === tailB) return true;
    var na = stripShopifyImageSizeInName(tailA.split("/").pop() || "").toLowerCase();
    var nb = stripShopifyImageSizeInName(tailB.split("/").pop() || "").toLowerCase();
    return na !== "" && na === nb;
  }

  function quickShopMainImgEffectiveSrc(imgEl) {
    if (!imgEl) return "";
    var $i = $(imgEl);
    return (
      ($i.attr("src") || "").trim() ||
      ($i.attr("data-src") || "").trim() ||
      ($i.attr("data-original") || "").trim() ||
      (imgEl.currentSrc || "").trim() ||
      (imgEl.src || "").trim()
    );
  }

  /**
   * 依次：mediaId → media.position → 1-based 序号 → 主图 img URL（与接口图同一文件）
   */
  function findGallerySlideIndex(carousel, opts) {
    opts = opts || {};
    var cells = carousel.querySelectorAll(".Carousel__Cell");
    var len = cells.length;
    var i;

    if (opts.mediaId) {
      for (i = 0; i < len; i++) {
        if (galleryMediaIdsMatch(cells[i].getAttribute("data-media-id"), opts.mediaId)) {
          return i;
        }
      }
    }
    if (opts.mediaPosition != null && opts.mediaPosition !== "") {
      var ps = String(opts.mediaPosition).trim();
      for (i = 0; i < len; i++) {
        var cp = cells[i].getAttribute("data-media-position");
        if (cp != null && String(cp).trim() === ps) return i;
      }
    }
    if (opts.imageUrl) {
      for (i = 0; i < len; i++) {
        var img =
          cells[i].querySelector("img.product_big_pic") ||
          cells[i].querySelector("img[data-original-src]") ||
          cells[i].querySelector("img");
        if (!img) continue;
        var src =
          img.getAttribute("data-original-src") ||
          img.getAttribute("data-src") ||
          img.currentSrc ||
          img.src;
        if (galleryImageUrlsLikelySame(opts.imageUrl, src)) return i;
      }
    }
    if (opts.productImageIndexOneBased != null && opts.productImageIndexOneBased !== "") {
      var n = parseInt(opts.productImageIndexOneBased, 10);
      if (!isNaN(n) && n >= 1) {
        var idx0 = n - 1;
        if (idx0 >= 0 && idx0 < len) return idx0;
      }
    }
    return -1;
  }

  /**
   * 详情：属性/主图切换后，让当前选中缩略图进入可视区。
   * - 竖条：优先 scrollProductNavToCenterNavIndex（按 .product_thumbnail-out 高度把选中项滚到垂直方向大致居中）；
   * - 横向 overflow 的 .Product__SlideshowNav：scrollLeft 居中；
   * - 延迟再跑一次，避免 Flickity 尚未完成布局时算偏。
   */
  function scrollProductDetailNavThumbIntoView(activeEl, $nav, $match) {
    if (!activeEl) return;

    function onePass() {
      if (
        $nav &&
        $nav.length &&
        $match &&
        $match.length
      ) {
        var navIndex = $nav.index($match);
        if (navIndex >= 0) {
          if (typeof scrollProductNavToCenterNavIndex === "function") {
            scrollProductNavToCenterNavIndex(navIndex, activeEl);
          } else if (
            typeof getProductNavState === "function" &&
            typeof scrollProductNavTo === "function"
          ) {
            var state = getProductNavState();
            var vc = state.visibleCount || 4;
            scrollProductNavTo(navIndex - Math.floor(vc / 2));
          }
        }
      }

      var navEl = activeEl.closest(".Product__SlideshowNav");
      if (navEl) {
        var cs = window.getComputedStyle(navEl);
        if (
          (cs.overflowX === "auto" || cs.overflowX === "scroll") &&
          navEl.scrollWidth > navEl.clientWidth + 2
        ) {
          var sr = activeEl.getBoundingClientRect();
          var pr = navEl.getBoundingClientRect();
          var delta = (sr.left + sr.right) / 2 - (pr.left + pr.right) / 2;
          var left = Math.max(
            0,
            Math.min(
              navEl.scrollLeft + delta,
              navEl.scrollWidth - navEl.clientWidth
            )
          );
          try {
            navEl.scrollTo({ left: left, behavior: "smooth" });
          } catch (eH) {
            navEl.scrollLeft = left;
          }
        }
      }

      try {
        activeEl.scrollIntoView({
          block: "nearest",
          inline: "center",
          behavior: "smooth",
        });
      } catch (eS) {}
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(onePass);
    });
    setTimeout(onePass, 60);
    setTimeout(onePass, 240);
  }

  function applyGallerySlideAtIndex(carousel, idx) {
    if (!carousel || idx < 0) return false;
    var cells = carousel.querySelectorAll(".Carousel__Cell");
    if (idx >= cells.length) return false;

    var flkty = null;
    if (typeof Flickity !== "undefined") {
      flkty = Flickity.data(carousel);
      if (!flkty && carousel === document.querySelector(".Product__Slideshow")) {
        flkty = window.flkty;
      }
    }
    var flickityOn =
      carousel.classList.contains("flickity-enabled") && flkty;

    if (flickityOn) {
      try {
        flkty.select(idx);
      } catch (errSel) {}
    } else {
      /**
       * watchCSS 未启用 Flickity 或实例尚未就绪时，主题用 .Carousel__Cell.is-selected 控制显隐
       * （见 theme.css .Carousel:not(.flickity-enabled) .Carousel__Cell:not(.is-selected)）
       */
      for (var ci = 0; ci < cells.length; ci++) {
        cells[ci].classList.toggle("is-selected", ci === idx);
      }
    }

    var mid = cells[idx] ? cells[idx].getAttribute("data-media-id") : null;
    var $root = $(carousel).closest(".big_small_pic, .Product__Gallery, .big_pic-product");
    if (!$root.length) $root = $(carousel).closest(".Product__Info");
    var $nav = $root.find(".Product__SlideshowNavImage");
    $nav.removeClass("is-selected");
    var $match = mid
      ? $nav.filter(function () {
          return galleryMediaIdsMatch($(this).attr("data-media-id"), mid);
        })
      : $();
    if (!$match.length) $match = $nav.eq(idx);
    else $match = $match.first();
    $match.addClass("is-selected");
    var el = $match[0];
    scrollProductDetailNavThumbIntoView(el, $nav, $match);
    return true;
  }

  function selectProductGallerySlide(opts, attempt) {
    attempt = attempt || 0;
    var carousel = document.querySelector(".Product__Slideshow");
    if (!carousel) return;
    var idx = findGallerySlideIndex(carousel, opts);
    if (idx < 0) return;
    if (applyGallerySlideAtIndex(carousel, idx)) return;
    if (attempt < 12) {
      setTimeout(function () {
        selectProductGallerySlide(opts, attempt + 1);
      }, 100);
    }
  }

  function isUsableSwatchPreviewUrl(url) {
    if (!url) return false;
    var s = String(url).trim();
    return s !== "" && s !== PLACEHOLDER_SVG && s.indexOf("data:image/svg") !== 0;
  }

  function getLoadedSwatchPreviewSrc($sw) {
    var imgEl = $sw && $sw.find(".SizeSwatch__img")[0];
    if (!imgEl) return "";
    var url = (imgEl.getAttribute("src") || imgEl.src || "").trim();
    if (!isUsableSwatchPreviewUrl(url)) return "";
    if (imgEl.complete && imgEl.naturalWidth > 0) return url;
    return "";
  }

  function upgradeOptionImageModalDom(modalEl) {
    var dialog = modalEl.querySelector(".KlaiyiOptionImageModal__dialog");
    if (!dialog) return;
    if (!dialog.querySelector(".KlaiyiOptionImageModal__frame")) {
      var img = dialog.querySelector(".KlaiyiOptionImageModal__img");
      if (img) {
        var frame = document.createElement("div");
        frame.className = "KlaiyiOptionImageModal__frame";
        img.parentNode.insertBefore(frame, img);
        frame.appendChild(img);
      }
    }
    dialog.querySelectorAll(".KlaiyiOptionImageModal__loader").forEach(function (node) {
      node.parentNode.removeChild(node);
    });
  }

  function ensureOptionImageModal() {
    var existing = document.getElementById("KlaiyiOptionImageModal");
    if (existing) {
      upgradeOptionImageModalDom(existing);
      return;
    }
    $("body").append(
      '<div id="KlaiyiOptionImageModal" class="KlaiyiOptionImageModal" aria-hidden="true" role="dialog">' +
        '<div class="KlaiyiOptionImageModal__backdrop" data-close="option-zoom"></div>' +
        '<div class="KlaiyiOptionImageModal__dialog">' +
        '<button type="button" class="KlaiyiOptionImageModal__close iconfont icon-close" aria-label="关闭" data-close="option-zoom"></button>' +
        '<div class="KlaiyiOptionImageModal__frame">' +
        '<img class="KlaiyiOptionImageModal__img" src="" alt="" width="300" height="400" />' +
        "</div></div></div>"
    );
  }

  function finishOptionImageModalLoad($m, $img, src, reqId) {
    if (reqId !== window.__klaiyiOptionModalReqId) return;
    $img
      .attr("src", src)
      .addClass("is-ready")
      .removeClass("is-preview");
    $m.find(".KlaiyiOptionImageModal__frame").addClass("is-expanded");
    $m.removeClass("is-loading");
  }

  window.openKlaiyiOptionImageModal = function (
    src,
    mediaId,
    productImageIndexOneBased,
    previewSrc
  ) {
    if (!src || src === PLACEHOLDER_SVG) return;
    ensureOptionImageModal();
    var $m = $("#KlaiyiOptionImageModal");
    var $frame = $m.find(".KlaiyiOptionImageModal__frame");
    var $img = $m.find(".KlaiyiOptionImageModal__img");
    var reqId = (window.__klaiyiOptionModalReqId = (window.__klaiyiOptionModalReqId || 0) + 1);

    $frame.removeClass("is-expanded");
    $m.addClass("is-loading");
    $img.removeClass("is-ready is-preview").attr("src", "");
    if (mediaId) $img.attr("data-media-id", mediaId);
    else $img.removeAttr("data-media-id");
    if (
      productImageIndexOneBased != null &&
      productImageIndexOneBased !== "" &&
      !isNaN(parseInt(productImageIndexOneBased, 10))
    ) {
      $img.attr("data-product-image-index", String(productImageIndexOneBased));
    } else {
      $img.removeAttr("data-product-image-index");
    }
    $img.attr("data-zoom-src", src);

    if (isUsableSwatchPreviewUrl(previewSrc)) {
      $img.attr("src", previewSrc).addClass("is-preview");
    }

    $m.addClass("is-open").attr("aria-hidden", "false");
    $("body").addClass("KlaiyiOptionImageModal-open");

    var loader = new Image();
    loader.onload = loader.onerror = function () {
      finishOptionImageModalLoad($m, $img, src, reqId);
    };
    loader.src = src;
    if (loader.complete) {
      finishOptionImageModalLoad($m, $img, src, reqId);
    }
  };

  function closeOptionImageModal() {
    var $m = $("#KlaiyiOptionImageModal");
    $m.removeClass("is-open is-loading").attr("aria-hidden", "true");
    $m.find(".KlaiyiOptionImageModal__frame").removeClass("is-expanded");
    $m.find(".KlaiyiOptionImageModal__img")
      .removeClass("is-ready is-preview")
      .removeAttr("data-zoom-src")
      .attr("src", "");
    $("body").removeClass("KlaiyiOptionImageModal-open");
    console.log('移除放大预览 modal');
    if (window.KlaiyiManualModalGate) {
      window.KlaiyiManualModalGate.release("pdp-option-image-zoom");
    } else if (typeof window.resumeRegistrationPopupsAfterManualModalClosed === "function") {
      window.resumeRegistrationPopupsAfterManualModalClosed("pdp-option-image-zoom");
    }
  }

  window.syncProductGalleryToMediaId = function (mediaId) {
    if (!mediaId) return;
    selectProductGallerySlide({ mediaId: mediaId });
  };

  /**
   * 接口 product_image_index 为商城主图册中的顺位（从 1 开始）
   */
  window.syncProductGalleryToProductImageIndex = function (oneBasedIndex) {
    if (oneBasedIndex == null || oneBasedIndex === "") return;
    selectProductGallerySlide({ productImageIndexOneBased: oneBasedIndex });
  };

  function escapeHtmlText(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function buildOptionImageInnerHtml(captionText) {
    return (
      '<span class="SizeSwatch__inner">' +
      '<span class="SizeSwatch__mediaWrap">' +
      '<img class="SizeSwatch__img" src="' +
      PLACEHOLDER_SVG +
      '" width="120" height="140" alt="" loading="lazy" decoding="async" />' +
      '<button type="button" class="SizeSwatch__zoom" aria-label="放大查看" data-action="option-image-zoom">' +
      '<img class="SizeSwatch__zoomIcon" src="' +
      OPTION_IMAGE_ZOOM_ICON_URL +
      '" width="16" height="16" alt="" aria-hidden="true" decoding="async" />' +
      "</button>" +
      "</span>" +
      '<span class="SizeSwatch__caption SizeSwatch__caption--lines-2">' +
      '<span class="SizeSwatch__captionText">' +
      escapeHtmlText(captionText) +
      "</span></span>" +
      "</span>"
    );
  }

  /**
   * 测量文案行数：1 行 line-height 22px，2 行 line-height 18px（详情 + 快购）
   */
  function measureOptionCaptionLines($caption) {
    if (!$caption || !$caption.length) return;
    var $text = $caption.find(".SizeSwatch__captionText").first();
    if (!$text.length) return;
    var el = $text[0];

    $caption.removeClass("SizeSwatch__caption--lines-1 SizeSwatch__caption--lines-2");

    $text.css({
      display: "block",
      overflow: "visible",
      lineHeight: CAPTION_LINE_HEIGHT_TWO_PX + "px",
      maxHeight: "none",
      WebkitLineClamp: "unset",
    });
    var scrollHeight = el.scrollHeight;
    $text.css({
      display: "",
      overflow: "",
      lineHeight: "",
      maxHeight: "",
      WebkitLineClamp: "",
    });

    if (scrollHeight <= CAPTION_TWO_LINE_SCROLL_THRESHOLD) {
      $caption.addClass("SizeSwatch__caption--lines-1");
    } else {
      $caption.addClass("SizeSwatch__caption--lines-2");
    }
  }

  function syncOptionCaptionLineClasses($scope) {
    var $root =
      $scope && $scope.length ? $scope : $(document);
    $root
      .find(".SizeSwatch--withOptionImage .SizeSwatch__caption")
      .each(function () {
        measureOptionCaptionLines($(this));
      });
  }

  /**
   * 第一个属性组：仅 option-0 对应的 block SizeSwatch 列表（与 Liquid 中 name="option-{{ parentloop.index0 }}" 一致）
   * @param {JQuery} [$scope] 默认详情 .ProductForm__Variants；快购传入 $(".quick_shop") 等
   */
  function getFirstOptionGroupSwatchList($scope) {
    var $root =
      $scope && $scope.length
        ? $scope
        : $(".ProductForm__Variants");
    return $root
      .find("ul.js-klaiyi-option-swatch-list")
      .filter(function () {
        return $(this).find('input.SizeSwatch__Radio[name="option-0"]').length > 0;
      })
      .first();
  }

  function firstOptionGroupHasConfiguredImage($firstUl, maps) {
    if (!$firstUl || !$firstUl.length) return false;
    var found = false;
    $firstUl.find(".SizeSwatch").each(function () {
      if (found) return false;
      var $label = $(this);
      if ($label.hasClass("SizeSwatch--withOptionImage")) return;
      var entry = resolveEntryForLabel($label, maps);
      if (entry && entry.url) {
        found = true;
        return false;
      }
    });
    return found;
  }

  /** 接口返回空列表时，还原已注入的属性图 swatch 为纯文案 */
  function revertOptionImageLabels($scope) {
    var $root =
      $scope && $scope.length ? $scope : $(".ProductForm__Variants");
    var $firstUl = getFirstOptionGroupSwatchList($root);
    if (!$firstUl.length) return;

    $firstUl.find(".SizeSwatch--withOptionImage").each(function () {
      var $label = $(this);
      var caption = $label.attr("data-value");
      if (caption === undefined || caption === null || String(caption).trim() === "") {
        caption = $label.find(".SizeSwatch__captionText").first().text().trim();
      }
      $label.removeClass(
        "SizeSwatch--withOptionImage SizeSwatch--layoutReservedBeforeImg"
      );
      $label.removeAttr("data-media-id data-product-image-index data-media-position");
      $label.text(caption || "");
    });

    $firstUl.removeClass("SizeSwatchList--optionImages");

    var isQuickShopScope =
      $root.is(".quick_shop") || $root.closest(".quick_shop").length > 0;
    setTimeout(function () {
      if (
        !isQuickShopScope &&
        typeof updateSwatchAndButtonStatus === "function" &&
        document.querySelector(".ProductForm #json-script")
      ) {
        updateSwatchAndButtonStatus();
      }
    }, 0);
  }

  /**
   * 仅在接口返回该选项值映射时注入 .SizeSwatch__inner；无映射则保持原文案 label。
   * 规则：无论有几个属性组，只根据「第一个属性组」是否配置了图片决定是否展示；
   * 仅第一个属性组内的 swatch 会展示图，其它组不展示（即使接口有图）。
   */
  function enhanceOptionImageLabelsFromMaps(maps, $scope, options) {
    options = options || {};
    var $root =
      $scope && $scope.length ? $scope : $(".ProductForm__Variants");
    var $firstUl = getFirstOptionGroupSwatchList($root);
    if (!$firstUl.length) return;

    var resolvedMaps =
      options.useVariantFallback === false
        ? maps
        : mergeMapsForResolve(
            maps,
            buildVariantImageFallbackMaps($scope || $root)
          );

    if (!firstOptionGroupHasConfiguredImage($firstUl, resolvedMaps)) {
      return;
    }

    var toEnhance = [];
    $firstUl.find(".SizeSwatch").each(function () {
      var $label = $(this);
      if ($label.hasClass("SizeSwatch--withOptionImage")) return;
      var entry = resolveEntryForLabel($label, resolvedMaps);
      if (!entry || !entry.url) return;
      toEnhance.push({ $label: $label, entry: entry });
    });

    toEnhance.forEach(function (cell) {
      cell.$label.addClass("SizeSwatch--layoutReservedBeforeImg");
    });
    if ($firstUl[0]) {
      void $firstUl[0].offsetHeight;
    }

    var $checkedRadio = $firstUl.find(".SizeSwatch__Radio:checked").first();
    var checkedLabelEl = $checkedRadio.length
      ? klaiyiLabelForSizeSwatchRadio($checkedRadio).get(0)
      : null;

    toEnhance.forEach(function (cell) {
      var $label = cell.$label;
      var entry = cell.entry;
      var caption =
        $label.attr("data-value") !== undefined && $label.attr("data-value") !== null
          ? String($label.attr("data-value"))
          : $label.text();

      $label.removeClass("SizeSwatch--layoutReservedBeforeImg");
      $label.addClass("SizeSwatch--withOptionImage");
      $label.html(buildOptionImageInnerHtml(caption));

      var $img = $label.find(".SizeSwatch__img");
      var useEager = checkedLabelEl && $label.get(0) === checkedLabelEl;
      cell.$img = $img;
      cell.useEager = useEager;
      $label.find(".SizeSwatch__zoom").attr("data-zoom-src", entry.url);

      if (entry.mediaId) {
        $label.attr("data-media-id", entry.mediaId);
      } else {
        $label.removeAttr("data-media-id");
      }
      if (
        entry.productImageIndex !== undefined &&
        entry.productImageIndex !== null &&
        entry.productImageIndex !== ""
      ) {
        $label.attr("data-product-image-index", entry.productImageIndex);
      } else {
        $label.removeAttr("data-product-image-index");
      }
      if (
        entry.mediaPosition !== undefined &&
        entry.mediaPosition !== null &&
        entry.mediaPosition !== ""
      ) {
        $label.attr("data-media-position", entry.mediaPosition);
      } else {
        $label.removeAttr("data-media-position");
      }
    });

    toEnhance.forEach(function (cell) {
      if (!cell.useEager) return;
      cell.$img
        .attr("src", cell.entry.url)
        .attr("loading", "eager")
        .attr("fetchpriority", "high");
    });

    var deferred = toEnhance.filter(function (cell) {
      return !cell.useEager;
    });
    var loadDeferredBatch = function (start) {
      var end = Math.min(start + 2, deferred.length);
      for (var di = start; di < end; di++) {
        deferred[di].$img.attr("src", deferred[di].entry.url).attr("loading", "lazy");
      }
      if (end < deferred.length) {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(function () {
            loadDeferredBatch(end);
          });
        } else {
          setTimeout(function () {
            loadDeferredBatch(end);
          }, 48);
        }
      }
    };
    if (deferred.length) {
      loadDeferredBatch(0);
    }

    if ($firstUl.find(".SizeSwatch--withOptionImage").length) {
      $firstUl.addClass("SizeSwatchList--optionImages");
    }

    syncOptionCaptionLineClasses($root);
    requestAnimationFrame(function () {
      syncOptionCaptionLineClasses($root);
    });

    var isQuickShopScope =
      $root.is(".quick_shop") || $root.closest(".quick_shop").length > 0;
    setTimeout(function () {
      if (
        !isQuickShopScope &&
        typeof updateSwatchAndButtonStatus === "function" &&
        document.querySelector(".ProductForm #json-script")
      ) {
        updateSwatchAndButtonStatus();
      }
    }, 0);

    // 默认进入详情页 / 打开快购弹窗时不同步主图与缩略图到「当前选中属性图」；
    // 仅用户切换属性（change / 主题内 label 点击逻辑）时由 syncProductGalleryToOptionImageLabelForRadio 联动。
  }

  /**
   * 与 input.SizeSwatch__Radio 成对的 label.SizeSwatch（优先 for=，避免 li 内多 label 误取）
   */
  function klaiyiLabelForSizeSwatchRadio($radio) {
    if (!$radio || !$radio.length) return $();
    var $ul = $radio.closest("ul.js-klaiyi-option-swatch-list");
    if (!$ul.length) {
      $ul = $radio.closest("ul");
    }
    var id = $radio.attr("id");
    if (id) {
      try {
        if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
          var $byCss = $ul.find("label.SizeSwatch[for=" + CSS.escape(id) + "]");
          if ($byCss.length) return $byCss.first();
        }
      } catch (eCss) {}
      var esc = String(id).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      var $byStr = $ul.find('label.SizeSwatch[for="' + esc + '"]');
      if ($byStr.length) return $byStr.first();
    }
    var $li = $radio.closest("li").find("label.SizeSwatch").first();
    if ($li.length) return $li;
    return $radio.next(".SizeSwatch");
  }

  /**
   * 与 .new_ProductItem_pic_all 内主图顺序一致（与 data-index 对齐）
   */
  function getQuickShopMainGalleryImgs$() {
    var $wrap = $(".quick_shop .new_ProductItem_pic_all").first();
    var $imgs = $wrap.find("img");
    if ($imgs.length) return $imgs;
    return $(".quick_shop .new_ProductItem_pic_all img");
  }

  /**
   * 首组带图 label：优先按 URL 在全轮播中定位（滚到对应位），再 media-id / media-position；
   * data-product-image-index 仅在与属性图 URL 一致时采用，避免接口序号与图序不一致时滚错位。
   */
  function findQuickShopSlideIndexFromOptionLabel($label) {
    if (!$label || !$label.length) return -1;
    if (!$label.hasClass("SizeSwatch--withOptionImage")) return -1;
    var $slides = $(".quick_shop .new_ProductItem_pic_all").first().find("img");
    if (!$slides.length) return -1;

    var $swImg = $label.find(".SizeSwatch__img").first();
    var optUrl =
      ($swImg.attr("src") || "").trim() ||
      ($swImg.attr("data-src") || "").trim();
    var hasOptUrl =
      !!optUrl &&
      optUrl.indexOf("data:image/svg") !== 0 &&
      optUrl !== PLACEHOLDER_SVG;

    if (hasOptUrl) {
      var foundUrl = -1;
      $slides.each(function (si) {
        var mu = quickShopMainImgEffectiveSrc(this);
        if (quickShopImageUrlsMatch(optUrl, mu)) {
          foundUrl = si;
          return false;
        }
      });
      if (foundUrl >= 0) return foundUrl;
    }

    var mid = $label.attr("data-media-id");
    if (mid) {
      var foundMid = -1;
      $slides.each(function (si) {
        var im = $(this).attr("data-media-id");
        if (im && galleryMediaIdsMatch(im, mid)) {
          foundMid = si;
          return false;
        }
      });
      if (foundMid >= 0) return foundMid;
    }

    var mpos = $label.attr("data-media-position");
    if (mpos != null && String(mpos).trim() !== "") {
      var ps = String(mpos).trim();
      var foundPos = -1;
      $slides.each(function (si) {
        var cp = $(this).attr("data-media-position");
        if (cp != null && String(cp).trim() === ps) {
          foundPos = si;
          return false;
        }
      });
      if (foundPos >= 0) return foundPos;
    }

    var idxAttr = $label.attr("data-product-image-index");
    if (idxAttr != null && String(idxAttr).trim() !== "") {
      var n = parseInt(String(idxAttr).trim(), 10);
      if (!isNaN(n) && n >= 1) {
        var i0 = n - 1;
        if (i0 >= 0 && i0 < $slides.length) {
          // 已在上方做过全轮播 URL 扫描；此处按接口声明的媒体序号滚位（变体 URL 不一致时仍能对齐 Swiper）
          return i0;
        }
      }
    }

    return -1;
  }

  /** 仅让与属性对应 data-index 的主图带 swiper-slide-active（避免 Swiper 多视窗改乱 class） */
  function klaiyiQuickShopApplySwiperSlideActiveClass(index) {
    var $all = $(".quick_shop .new_ProductItem_pic_all").first().find("img");
    if (!$all.length) {
      $all = getQuickShopMainGalleryImgs$();
    }
    $all.removeClass("swiper-slide-active swiper-slide-prev swiper-slide-next");
    $all
      .filter('[data-index="' + index + '"]')
      .addClass("swiper-slide-active")
      .end()
      .filter('[data-index="' + (index - 1) + '"]')
      .addClass("swiper-slide-prev")
      .end()
      .filter('[data-index="' + (index + 1) + '"]')
      .addClass("swiper-slide-next");
  }

  /**
   * 快购主图/小图切换（与 newklayi.js 内 scrollToIndex 逻辑一致，供属性图联动不依赖 1s 延迟）
   * M 端常无左侧缩略图条（未插入 .quick_shop_slideshowNav），不可因 $items 为空而 return，否则 slideTo / active class 都不会执行。
   */
  function klaiyiQuickShopSlideToIndex(index) {
    var $items = $(
      ".quick_shop_main .quick_shop_slideshowNav img.quick_shop_smallpic_list"
    );
    if (!$items.length) {
      $items = $(".quick_shop .quick_shop_slideshowNav img.quick_shop_smallpic_list");
    }
    var $nav = $(".quick_shop .quick_shop_slideshowNav").first();
    var itemHeight = 85;
    var containerHeight =
      $(".quick_shop .quick_shop_slideshowNavWrapper").first().height() || 0;
    var totalCount = $items.length;
    var $mainSlides = $(".quick_shop .new_ProductItem_pic_all").first().find("img");
    var maxFromMain = Math.max(0, $mainSlides.length - 1);
    var maxIdx = totalCount > 0 ? totalCount - 1 : maxFromMain;
    index = Math.max(0, Math.min(index, maxIdx));

    var sw =
      typeof window !== "undefined" && window.quick_shop_swiper
        ? window.quick_shop_swiper
        : null;
    if (sw && typeof sw.slideTo === "function") {
      try {
        sw.slideTo(index, 0, false);
      } catch (eSw) {}
    }

    if ($items.length) {
      $items.removeClass("quick_shop_smallpic_active");
      $items
        .filter('[data-index="' + index + '"]')
        .addClass("quick_shop_smallpic_active");
    }
    klaiyiQuickShopApplySwiperSlideActiveClass(index);
    if (sw && typeof sw.slideTo === "function") {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          klaiyiQuickShopApplySwiperSlideActiveClass(index);
        });
      });
    }
    if (!sw || typeof sw.slideTo !== "function") {
      var largeImageWidth =
        ($(".quick_shop .new_ProductItem_pic_wai").width() || 0) + 5;
      $(".quick_shop .new_ProductItem_pic_all").css(
        "transform",
        "translate3d(" + -largeImageWidth * index + "px, 0px, 0px)"
      );
    }
    if ($nav.length && totalCount > 0) {
      var targetTop = index * itemHeight;
      var contentHeight = itemHeight * totalCount;
      var newMarginTop = -targetTop;
      var maxScroll = contentHeight - containerHeight;
      if (-newMarginTop > maxScroll) newMarginTop = -maxScroll;
      if (newMarginTop > 0) newMarginTop = 0;
      $nav.stop().animate({ "margin-top": newMarginTop + "px" }, 200);
    }
    var total = $(".quick_shop .quick_shop_slideshowNav img.quick_shop_smallpic_list").length;
    $(".quick_shop .newicon_up")
      .toggleClass("disabled", index <= 0)
      .css("color", index <= 0 ? "#d5d1d1" : "#000");
    $(".quick_shop .newicon_down")
      .toggleClass("disabled", total > 0 && index >= total - 1)
      .css(
        "color",
        total > 0 && index >= total - 1 ? "#d5d1d1" : "#000"
      );
  }

  function syncQuickShopGalleryFromOptionImageOpts(opts) {
    var idx = -1;
    var $slides = getQuickShopMainGalleryImgs$();
    opts = opts || {};

    if (opts.imageUrl) {
      $slides.each(function (i) {
        var src = quickShopMainImgEffectiveSrc(this);
        if (quickShopImageUrlsMatch(opts.imageUrl, src)) {
          idx = i;
          return false;
        }
      });
    }
    if (idx < 0 && opts.mediaId) {
      $slides.each(function (i) {
        var mid = $(this).attr("data-media-id");
        if (mid && galleryMediaIdsMatch(mid, opts.mediaId)) {
          idx = i;
          return false;
        }
      });
    }
    if (idx < 0 && opts.mediaPosition != null && opts.mediaPosition !== "") {
      var ps = String(opts.mediaPosition).trim();
      $slides.each(function (i) {
        var cp = $(this).attr("data-media-position");
        if (cp != null && String(cp).trim() === ps) {
          idx = i;
          return false;
        }
      });
    }
    if (
      idx < 0 &&
      opts.productImageIndexOneBased != null &&
      opts.productImageIndexOneBased !== ""
    ) {
      var n = parseInt(opts.productImageIndexOneBased, 10);
      if (!isNaN(n) && n >= 1) {
        var i0 = n - 1;
        if (i0 >= 0 && i0 < $slides.length) idx = i0;
      }
    }
    if (idx < 0) {
      var $la = $(
        ".quick_shop ul.js-klaiyi-option-swatch-list label.SizeSwatch.is-active"
      ).first();
      if ($la.length && $la.hasClass("SizeSwatch--withOptionImage")) {
        var tryIdx = findQuickShopSlideIndexFromOptionLabel($la);
        if (tryIdx >= 0) idx = tryIdx;
      }
    }
    if (idx >= 0 && $slides.length) {
      idx = Math.max(0, Math.min(idx, $slides.length - 1));
      klaiyiQuickShopSlideToIndex(idx);
    }
  }

  /** 快购弹窗内：根据首组当前选中（:checked 或 .is-active）属性图同步主图/小图 */
  function syncQuickShopGalleryToCheckedOptionImages() {
    var $firstUl = $(".quick_shop ul.js-klaiyi-option-swatch-list")
      .filter(function () {
        return $(this).find('input.SizeSwatch__Radio[name="option-0"]').length > 0;
      })
      .first();
    if (!$firstUl.length) {
      $firstUl = $(".quick_shop ul.js-klaiyi-option-swatch-list").first();
    }
    if (!$firstUl.length) return;

    var $label = $firstUl.find("label.SizeSwatch.is-active").first();
    if (
      !$label.length ||
      !$label.hasClass("SizeSwatch--withOptionImage")
    ) {
      var $radio = $firstUl.find(".SizeSwatch__Radio:checked").first();
      $label = $radio.length ? klaiyiLabelForSizeSwatchRadio($radio) : $();
    }
    if (!$label.length || !$label.hasClass("SizeSwatch--withOptionImage")) {
      return;
    }

    var domIdx = findQuickShopSlideIndexFromOptionLabel($label);
    if (domIdx >= 0) {
      klaiyiQuickShopSlideToIndex(domIdx);
      return;
    }

    var imgSrc = $label.find(".SizeSwatch__img").attr("src") || "";
    var lastOpts = {
      mediaId: $label.attr("data-media-id"),
      productImageIndexOneBased: $label.attr("data-product-image-index"),
      mediaPosition: $label.attr("data-media-position"),
      imageUrl: imgSrc && imgSrc !== PLACEHOLDER_SVG ? imgSrc : "",
    };
    syncQuickShopGalleryFromOptionImageOpts(lastOpts);
  }

  window.klaiyiQuickShopSyncMainGalleryFromActiveOption =
    syncQuickShopGalleryToCheckedOptionImages;

  window.klaiyiQuickShopSlideToIndex = klaiyiQuickShopSlideToIndex;

  /** 供 newklayi M 端 Swiper slideChange：仅刷新主图 active 绿框 class */
  window.klaiyiQuickShopApplySlideActiveByIndex = function (i) {
    if (typeof i !== "number" || isNaN(i) || i < 0) return;
    klaiyiQuickShopApplySwiperSlideActiveClass(i);
  };

  /** 当前选中各组属性图中，按 DOM 顺序最后一组驱动主图（与最后一次切换语义接近） */
  function syncGalleryToCheckedOptionImages() {
    var lastOpts = null;

    $(".ProductForm__Variants ul.js-klaiyi-option-swatch-list").each(function () {
      var $radio = $(this).find(".SizeSwatch__Radio:checked").first();
      if (!$radio.length) return;
      var $label = klaiyiLabelForSizeSwatchRadio($radio);
      if (!$label.length || !$label.hasClass("SizeSwatch--withOptionImage")) return;
      var imgSrc = $label.find(".SizeSwatch__img").attr("src") || "";
      lastOpts = {
        mediaId: $label.attr("data-media-id"),
        productImageIndexOneBased: $label.attr("data-product-image-index"),
        mediaPosition: $label.attr("data-media-position"),
        imageUrl: imgSrc && imgSrc !== PLACEHOLDER_SVG ? imgSrc : "",
      };
    });

    if (!lastOpts) return;
    selectProductGallerySlide(lastOpts);
  }

  window.syncProductGalleryToOptionImageLabelForRadio = function (radioEl) {
    if (!radioEl) return;
    var $radio = $(radioEl);
    if (
      $radio.closest(".quick_shop").length &&
      window.__quickShopSuppressOptionGallerySync
    ) {
      return;
    }
    // 取消本组选中时会对组内每个 radio 派发 change，此时均无 :checked；
    // 若仍按 label 去 selectProductGallerySlide，会连续执行并以「列表最后一个」为准滚主图。
    if (!$radio.is(":checked")) return;
    var $label = klaiyiLabelForSizeSwatchRadio($radio);
    if (!$label.length || !$label.hasClass("SizeSwatch--withOptionImage")) return;
    var imgSrc = $label.find(".SizeSwatch__img").attr("src") || "";
    var opts = {
      mediaId: $label.attr("data-media-id"),
      productImageIndexOneBased: $label.attr("data-product-image-index"),
      mediaPosition: $label.attr("data-media-position"),
      imageUrl: imgSrc && imgSrc !== PLACEHOLDER_SVG ? imgSrc : "",
    };
    if ($radio.closest(".quick_shop").length) {
      var ix = findQuickShopSlideIndexFromOptionLabel($label);
      if (ix >= 0) {
        klaiyiQuickShopSlideToIndex(ix);
        return;
      }
      syncQuickShopGalleryFromOptionImageOpts(opts);
      return;
    }
    selectProductGallerySlide(opts);
  };

  function applyOptionImagesFromJson(json, $scope) {
    if (!json) return;
    if (isOptionImagesApiExplicitlyEmpty(json)) {
      revertOptionImageLabels($scope);
      return;
    }
    var maps = parseOptionImagesPayload(json);
    enhanceOptionImageLabelsFromMaps(maps, $scope, { useVariantFallback: true });
  }

  function applyOptionImagesForCurrentProduct($scope) {
    var cfg = window.__KLAIYI_OPTION_IMAGES__ || {};
    if (!cfg.productId) return Promise.resolve(null);

    var key = String(cfg.productId);
    var store = window.__KLAIYI_OPTION_IMAGES_DATA__;
    // 已有缓存时直接注入，勿再走 klaiyiStartOptionImagesFetch：
    // 后者在命中缓存时会同步派发 klaiyi:option-images-ready，易与下方监听形成死循环。
    if (store && store[key]) {
      applyOptionImagesFromJson(store[key], $scope);
      return Promise.resolve(store[key]);
    }

    if (typeof window.klaiyiStartOptionImagesFetch === "function") {
      var started = window.klaiyiStartOptionImagesFetch(false);
      if (started && typeof started.then === "function") {
        return started.then(function (json) {
          applyOptionImagesFromJson(json, $scope);
          return json;
        });
      }
    }

    return fetchOptionImagesJson(cfg.productId).then(function (json) {
      applyOptionImagesFromJson(json, $scope);
      return json;
    });
  }

  function fetchOptionImagesJson(productId) {
    var cfg = window.__KLAIYI_OPTION_IMAGES__ || {};
    var auth = (cfg.authorization || "").trim();
    if (!auth || !productId) return Promise.resolve(null);

    var key = String(productId);
    if (
      typeof window.klaiyiStartOptionImagesFetch === "function" &&
      String(cfg.productId) === key
    ) {
      return window.klaiyiStartOptionImagesFetch(false);
    }

    window.__KLAIYI_OPTION_IMAGES_DATA__ = window.__KLAIYI_OPTION_IMAGES_DATA__ || {};
    window.__KLAIYI_OPTION_IMAGES_FETCH_PROMISES__ =
      window.__KLAIYI_OPTION_IMAGES_FETCH_PROMISES__ || {};
    if (window.__KLAIYI_OPTION_IMAGES_FETCH_PROMISES__[key]) {
      return window.__KLAIYI_OPTION_IMAGES_FETCH_PROMISES__[key];
    }

    var endpoint =
      cfg.endpoint || "https://plugin.kriyya.com/api/klaiyi/option_images";
    var url =
      endpoint +
      (endpoint.indexOf("?") >= 0 ? "&" : "?") +
      "product_id=" +
      encodeURIComponent(productId);
    var promise = fetch(url, {
      method: "GET",
      headers: {
        Authorization: auth.indexOf("Bearer ") === 0 ? auth : "Bearer " + auth,
        Accept: "application/json",
      },
      credentials: "omit",
    })
      .then(function (r) {
        if (!r.ok) throw new Error("option_images " + r.status);
        return r.json();
      })
      .then(function (json) {
        window.__KLAIYI_OPTION_IMAGES_DATA__[key] = json;
        return json;
      })
      .catch(function () {
        var store = window.__KLAIYI_OPTION_IMAGES_DATA__;
        if (store && store[key]) return store[key];
        return null;
      })
      .finally(function () {
        delete window.__KLAIYI_OPTION_IMAGES_FETCH_PROMISES__[key];
      });
    window.__KLAIYI_OPTION_IMAGES_FETCH_PROMISES__[key] = promise;
    return promise;
  }

  /**
   * 快购弹窗：按当前商品 ID 拉取 option_images 并仅增强 .quick_shop 内首组列表
   */
  window.klaiyiApplyOptionImagesToQuickShop = function (productId) {
    if (!productId) return Promise.resolve();
    return fetchOptionImagesJson(productId)
      .then(function (json) {
        applyOptionImagesFromJson(json, $(".quick_shop"));
      })
      .catch(function () {});
  };

  function fetchAndApplyOptionImages() {
    var cfg = window.__KLAIYI_OPTION_IMAGES__;
    if (!cfg || !cfg.productId) return;
    var auth = (cfg.authorization || "").trim();
    if (!auth) return;
    applyOptionImagesForCurrentProduct().catch(function () {});
  }

  function pushPropertyImageOpenGtag($sw) {
    if (typeof gtag !== "function") return;
    var contentGroup =
      (typeof window.getTrackPageValue === "function" &&
        window.getTrackPageValue()) ||
      "unknown";
    var cfg = window.__KLAIYI_OPTION_IMAGES__ || {};
    var productId = cfg.productId
      ? String(cfg.productId)
      : ($sw && $sw.closest(".quick_shop").find("form").attr("data-id")) ||
        $(".quick_shop form").attr("data-id") ||
        "unknown";
    var propertyValue = "unknown";
    if ($sw && $sw.length) {
      var dataValue = $sw.attr("data-value");
      if (dataValue !== undefined && dataValue !== null && String(dataValue).trim()) {
        propertyValue = String(dataValue).trim();
      } else {
        var captionText = $sw.find(".SizeSwatch__captionText").first().text();
        if (captionText && String(captionText).trim()) {
          propertyValue = String(captionText).trim();
        }
      }
    }
    gtag("event", "property", {
      event_category: contentGroup,
      event_label: "property::open-" + productId + "-" + propertyValue,
      event_action: "click",
      send_to: "G-F0NKM0YQCD",
    });
  }

  $(document).on("click", ".SizeSwatch__zoom", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $btn = $(this).closest(".SizeSwatch__zoom");
    var $sw = $btn.closest(".SizeSwatch");
    pushPropertyImageOpenGtag($sw);
    var src =
      $btn.attr("data-zoom-src") ||
      $sw.find(".SizeSwatch__img").attr("src") ||
      "";
    var previewSrc = getLoadedSwatchPreviewSrc($sw);
    var mediaId = $sw.attr("data-media-id") || $sw.data("media-id");
    var pidx =
      $sw.attr("data-product-image-index") || $sw.data("product-image-index");
    window.openKlaiyiOptionImageModal(src, mediaId, pidx, previewSrc);
    if (window.KlaiyiManualModalGate) {
      window.KlaiyiManualModalGate.acquire("pdp-option-image-zoom");
    } else if (typeof window.pauseRegistrationAutoPopupsForManualModal === "function") {
      window.pauseRegistrationAutoPopupsForManualModal("pdp-option-image-zoom");
    } else {
      sessionStorage.setItem("otherAlter", "true");
    }
    sessionStorage.setItem("DetainmentAlterIndex", "true");
    console.log('放大打印');
    
  });

  $(document).on("click", ".KlaiyiOptionImageModal__img", function () {
    var $img = $(this);
    var opts = {
      mediaId: $img.attr("data-media-id"),
      productImageIndexOneBased: $img.attr("data-product-image-index"),
      imageUrl: $img.attr("data-zoom-src") || $img.attr("src") || "",
    };
    if ($(".quick_shop_main").is(":visible")) {
      syncQuickShopGalleryFromOptionImageOpts(opts);
    } else {
      selectProductGallerySlide(opts);
    }
  });

  $(document).on("click", "#KlaiyiOptionImageModal.is-open", function () {
    closeOptionImageModal();
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $("#KlaiyiOptionImageModal").hasClass("is-open")) {
      closeOptionImageModal();
    }
  });

  /** 快购：用户切换属性时联动主图（打开弹窗初始化阶段由 __quickShopSuppressOptionGallerySync 跳过） */
  $(document).on("change", ".quick_shop input.SizeSwatch__Radio", function () {
    if (window.__quickShopSuppressOptionGallerySync) return;
    window.syncProductGalleryToOptionImageLabelForRadio(this);
  });

  var captionLineResizeTimer;
  $(window).on("resize.klaiyiOptionCaption", function () {
    clearTimeout(captionLineResizeTimer);
    captionLineResizeTimer = setTimeout(function () {
      syncOptionCaptionLineClasses($(".ProductForm__Variants"));
      if ($(".quick_shop").length) {
        syncOptionCaptionLineClasses($(".quick_shop"));
      }
    }, 150);
  });

  document.documentElement.addEventListener("klaiyi:option-images-ready", function (e) {
    if (!$(".ProductForm__Variants").length) return;
    // 只用事件里的数据注入，禁止再调 applyOptionImagesForCurrentProduct → startFetch → notify 死循环
    var detail = e && e.detail;
    var json = detail && detail.data;
    if (json != null) {
      applyOptionImagesFromJson(json);
      return;
    }
    var cfg = window.__KLAIYI_OPTION_IMAGES__ || {};
    var store = window.__KLAIYI_OPTION_IMAGES_DATA__;
    var key = cfg.productId != null ? String(cfg.productId) : "";
    if (key && store && store[key]) {
      applyOptionImagesFromJson(store[key]);
    }
  });

  $(function () {
    fetchAndApplyOptionImages();
  });
})(jQuery);
